import React from 'react';

const LayoutContentContainer = (props) => {
    return <>
        <style>
            {`
                .layout-content-container p, .layout-content-container ul, .layout-content-container ol {
                    line-height: 1.75;
                }

                .layout-content-container h1,
                .layout-content-container h2,
                .layout-content-container h3,
                .layout-content-container h4,
                .layout-content-container h5,
                .layout-content-container h6 {
                    padding-top: 0.25em;
                    padding-bottom: 0.75em;
                }

                .layout-content-container {
                    margin-top: 3rem;
                    margin-bottom: 6rem;
                    padding: 1.5rem;
                }
                
                .layout-content-container__card {
                    padding: 3.5rem;
                }

                @media(max-width: 66rem) {
                    .layout-content-container {
                        margin-top: 0;
                        margin-bottom: 0;
                    }

                    .layout-content-container__card {
                        padding: 2rem;
                    }
                }
                @media(max-width: 30rem) {
                    .layout-content-container {
                        margin-top: 0;
                        margin-bottom: 0;
                    }

                    .layout-content-container__card {
                        padding: 1.5rem;
                    }
                }
            `}
        </style>
        <div
            className="layout-content-container"
            style={
                {
                    maxWidth: '64rem',
                    width: '100%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    position: 'relative',
                    ...props.style
                }
            }
        >
            <div
                className="layout-content-container__card"
                style={
                    {
                        border: '3px solid #ececec',
                        borderRadius: '1.5rem',
                        background: '#fff',
                        ...props.styleCard,
                        boxShadow: '.100rem .125rem 0.45rem rgba(0,0,0,0.045)'
                        // boxShadow: '.100rem .125rem .75rem rgba(0,0,0,0.085)'
                    }
                }
            >
                {props.children}
            </div>
        </div>
    </>
}

export default LayoutContentContainer;
